module.exports = __webpack_public_path__ + "img/inge-v9-6.13e58b75.png";